/** 下拉/日历等面板区域：hover 时不显示筛选器 hoverTip */
export const FILTER_HOVER_TIP_PANEL_SELECTORS = [
  '.tea-dropdown-box',
  '.tea-overlay',
  '.tea-calendar',
  '.tea-calendar-table',
  '.tea-popover',
  '[data-filter-hover-tip-ignore]',
] as const;

/** 筛选器触发区域：hover 时显示 hoverTip */
export const FILTER_HOVER_TIP_TRIGGER_SELECTORS = [
  '.tea-dropdown__header',
  '.tea-datepicker__input',
  '.dtb-datepicker-prefix',
] as const;

/**
 * 用于判断是否为「带下拉面板的筛选器」。
 * wrapper 内不存在这些节点时，整个 wrapper 视为触发区（Switch/Checkbox 等）。
 */
export const FILTER_HOVER_TIP_PANEL_ROOT_MARKERS = [
  '.tea-dropdown',
  '.tea-datepicker',
] as const;
